module.exports = __webpack_public_path__ + "static/media/update-24px.c9f060a8.svg";